import { createFileRoute } from '@tanstack/react-router'
import LobbyPageClient from '#/components/lobby/LobbyPageClient'

export const Route = createFileRoute('/_authenticated/$slug/messages')({
  component: LobbyPageClient,
})
